import messages from './gallery-featured-translations';
import { SharedService } from '../../../shared/services/sharedService';

export default {
    name: 'instamapsGalleryFeatured',
    i18n: {
        messages,
    },
    filters: {
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
    },
    props: {
        selectedLang: { type: String },
        availableMaps: { type: Number },
        btnUrl: {type: String },
        lastActivity: {
            validator: function (val) {
                return val || true;
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/gallery-featured/gallery-featured.js